import React from 'react';
import { Linking } from 'react-native';
import { general } from '~/assets/imgs';
import Button from '~/components/Button';
import AuthWebLayout from '~/screens/Auth/layout/AuthLayout/AuthWebLayout';
import { LanguageProps } from '~/screens/Auth/layout/AuthLayout/types';
import { t } from '~/utils/i18n';
import { MainImage, Title, Desc } from './style';

type BrokenLinkLayoutProps = LanguageProps & {
  openContactSupport: () => void;
};

export default function ServerError({
  selectedLocale,
  onSelectedLocale,
  openContactSupport,
}: BrokenLinkLayoutProps): JSX.Element {
  return (
    <AuthWebLayout languageProps={{ selectedLocale, onSelectedLocale }}>
      <>
        <MainImage source={general.flame} resizeMode={'contain'}></MainImage>
        <Title>{t('serverError.title')}</Title>
        <Desc>{t('serverError.desc')}</Desc>
        <Button
          type={'secondary-base'}
          text={t('serverError.goToStatus')}
          onPress={() => Linking.openURL('https://status.gradoo.com')}
          bottomMargin={10}
          flex={true}
        ></Button>
        <Button
          type={'secondary-contrast'}
          text={t('serverError.contactSupport')}
          onPress={openContactSupport}
          bottomMargin={10}
          flex={true}
        ></Button>
      </>
    </AuthWebLayout>
  );
}
